import Component from '@glimmer/component';

import type { PreviewCompare } from 'webapp/components/data-select/edit/data-preview';

interface Args {
	compare: PreviewCompare | null;
	isSingleCompare: boolean;
}

export default class DataSelectEditDataPreviewCompareComponent extends Component<Args> {
	get cellClass() {
		return this.args.isSingleCompare ? 'compare l' : 'compare r';
	}

	get isChangeStrShown() {
		return !!this.args.compare?.changeStr;
	}

	get isDateShown() {
		return !!this.args.compare?.date && !this.args.isSingleCompare;
	}
	<template>
		<td class={{this.cellClass}}>
			{{#if @compare}}
				{{@compare.valueStr}}
				{{#if this.isChangeStrShown}}
					<span class="indicator {{@compare.indicatorClass}}">
						{{@compare.changeStr}}
					</span>
				{{/if}}
				{{#if this.isDateShown}}
					<small>({{@compare.date}})</small>
				{{/if}}
			{{else}}
				-
			{{/if}}
		</td>
		{{#if @isSingleCompare}}
			<td class={{this.cellClass}}>
				{{#if @compare.date}}
					<small>({{@compare.date}})</small>
				{{else}}
					-
				{{/if}}
			</td>
		{{/if}}
	</template>
}
